
Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TextAreaAttributes = (function () {

    function TextAreaAttributes() {

        Monet.UI.Fields.Base.apply(this, arguments);

        this.createBaseStructure();

        this.value = "";
        this.attributes = [];
        this.input = null;
        this.bubblingMask = null;

        let baseElement = null;

        this.createElement = function () {
            if (!baseElement) {
                this.wrapper = document.createElement('div');
                this.wrapper.className = "wrapper";
                this.input = document.createElement('textarea');
                this.input.className = "textareaInput";
                this.rootEl.className += ' textAreaAttributes';
                this.input.autocomplete = 'off';
                this.addEventListnerToTextArea();

                this.bubblingMask = document.createElement('div');
                this.bubblingMask.className = 'bubblingMask';
                this.bubblingMask.addEventListener('click', () => {
                    this.input.focus();
                });

                baseElement = this.input;

                if (this.maxSize) {
                    this.input.maxLength = this.maxSize;
                }

                const listAttributesContent = document.createElement('div');
                listAttributesContent.id = "listAttributesContent";
                const listAttributes = this.createList();
                listAttributesContent.appendChild(listAttributes);

                this.wrapper.appendChild(this.input);
                this.wrapper.appendChild(this.bubblingMask);
                this.wrapper.appendChild(listAttributesContent);
                this.rootEl.appendChild(this.wrapper);
            }
            this.handleBubblingMask();
        };

        this.handleTextAreaChange = () => {
            const value = this.input.value;
            this.setValue(value);
        };

        this.addEventListnerToTextArea = function() {
            this.input.addEventListener('input', this.handleTextAreaChange);
        };

        this.createList = function () {
            let content = document.createElement("div");
            content.className = "attributesContent";
            
            const fieldListElement = this.renderFieldList();
            content.appendChild(fieldListElement);
            const pickList = $(content.querySelector('.pickListFieldFilters'));
            pickList.selectpicker({
                callback: (val) => {
                    this.appendValue(`@${val}@ `);

                    pickList.selectpicker('val', 'default');
                    pickList.selectpicker('refresh');
                },
                liveSearchNormalize: true
            });

            pickList.selectpicker('val', 'default');
            pickList.selectpicker('refresh');
            pickList.selectpicker('show');
            return content;
        };

        this.renderFieldList = function () {
            var fragment = document.createDocumentFragment();
            var select = document.createElement('select');
            select.className = 'pickListFieldFilters';
            select.setAttribute('data-live-search', 'true');
            select.setAttribute('title', Monet.I18n.getResourcesByKey("event.button.add.bubble"));

            for (var attribute in this.attributes) {
                select.appendChild(this.createOptionElement(this.attributes[attribute]));
            }
            fragment.appendChild(select);

            return fragment;
        };

        this.createOptionElement = function (item) {
            var translated = Monet.I18n.getResourcesByKey(item.label);
            var option = document.createElement('option');
            option.setAttribute('value', item.value);
            option.setAttribute('label', translated);
            option.innerHTML = translated;
            return option;
        };

        this.getValue = function () {
            if (this.input) {
                this.value = this.input.value;
            }
            return this.value;
        };

        this.clear = function() {
            const emptyList = [];
            this.setValue('');
            this.setAttributes(emptyList);
        };

        this.appendValue = function (value) {
            if (value || value === '' || value === 0) {
                this.value += value;
            }
            this.setInputValue();
        }

        this.setValue = function (value) {
            if (value || value === '' || value === 0) {
                this.value = value;
            }
            this.setInputValue();
        };

        this.setInputValue = function () {
            if (this.input) {
                this.input.value = new Monet.Format.TEXT(this.value).getValue();
                this.handleBubblingMask();
            }
        };

        this.setAttributes = function (attributes) {
            this.attributes = attributes;
            const listAttributesContent = document.getElementById("listAttributesContent");
            listAttributesContent.innerHTML = "";
            listAttributesContent.appendChild(this.createList());
        };

        this.render = function () {
            this.createElement();
            this.setInputValue();
            return this.rootEl;
        };

        this.handleBubblingMask = function () {
            if(!this.bubblingMask) return;
            if (this.value) {
                const words = this.value.split(' ');
                const regex = /@([^\s]+)@/;
                let newHTML = '';
                for (let i = 0; i < words.length; i++) {
                    if (regex.test(words[i])) {
                        const bubbleWord = words[i].match(regex)[1];
                        const bubbleTag = words[i].match(regex)[0];
                        const bubble = document.createElement('span');
                        const leftAtSpan = document.createElement('span');
                        const rightAtSpan = document.createElement('span');
                        const tagIndex = words[i].indexOf(bubbleTag);
                        const leftLeftOvers = words[i].substring(0, tagIndex);
                        const rightLeftOvers = words[i].substring(leftLeftOvers.length + bubbleTag.length);

                        leftAtSpan.className = 'bubbling-invisible-at';
                        leftAtSpan.innerHTML = '@';

                        rightAtSpan.className = 'bubbling-invisible-at';
                        rightAtSpan.innerHTML = '@';

                        bubble.className = 'bubbling-bubble';
                        bubble.innerHTML = leftAtSpan.outerHTML + Monet.I18n.getResourcesByKey('SelectKeyResource.' + bubbleWord) + rightAtSpan.outerHTML;
                        newHTML += `${leftLeftOvers}${bubble.outerHTML}${rightLeftOvers} `;
                    } else {
                        newHTML += `  ${words[i]}  `;
                    }
                }
                this.bubblingMask.innerHTML = newHTML;
            } else {
                this.bubblingMask.innerHTML = "";
            }
        }

        this.setPlaceHolder = function (text) {
            if (this.input) {
                this.input.placeholder = text;
            } else {
                var error = new Monet.Exception.ReturnError(
                    this, 'Monet.UI.Fields.TextAreaAttributes: setPlaceHolder: this.input is null'
                );
                error.console();
            }

        };

    }

    return TextAreaAttributes;

}());